import React, { useState } from "react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useLocation, useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { SEND_TRAINER_APPOINTMENT } from "queries/mutations";
import useMakeScrollable from "custom_hooks/make-scrollable";
import backArrow from '../../assets/images/left_arrow.png';

const AppointmentBook = () => {
  useMakeScrollable()
  const location = useLocation();
  const { trainer } = location.state || {};
  const [date, setDate] = useState(null);
  const [time, setTime] = useState('');
  const [calenderOpen, setCalenderOpen] = useState(false);
  const history = useHistory();
  const [message, setMessage] = useState('')

  const toggleCalendar = () => {
    setCalenderOpen(!calenderOpen);
  };

  const [sendTrainerAppointment] = useMutation(SEND_TRAINER_APPOINTMENT, {
    onCompleted: (response) => {
      const isSuccess = response?.sendTrainerAppointment
      if (isSuccess) {
        history.push({
          pathname: '/thank-you',
          state: {
            title: "Vielen Dank für deine Terminvereinbarung!",
            text: "Du wirst per Mail über deinen gewünschten Termin informiert."
          }
        });
      }
    },
    onError: (data) => {
      console.log("error", data);
    },
  });

  const combineDateTime = () => {
    if (!date || !time) return null; 

    const [hours, minutes] = time.split(':'); 
    const selectedDateTime = new Date(date);

    selectedDateTime.setHours(hours);
    selectedDateTime.setMinutes(minutes);
    selectedDateTime.setSeconds(0); 

    return selectedDateTime.toISOString(); 
  };

  const handleButtonClick = () => {
    const dateTimeUtc = combineDateTime();
    if (dateTimeUtc) {
      sendTrainerAppointment({ 
        variables: { 
          trainerId: trainer.trainer.id, 
          message,
          date: dateTimeUtc 
        } 
      });
    } else {
      alert("Please select both a date and a time for your appointment.");
    }
  };


  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleBack = () => {
    history.goBack() 
  };

  return (
    <div className='appointment-book scrollable'>
      <img 
        src={backArrow} 
        alt="back" 
        className="points-header-arrow" 
        onClick={handleBack} 
      />
      <div className="appointment-book-info">
        <div>Deine Referentin</div>
        <input value={trainer ? `${trainer.trainer.firstName} ${trainer.trainer.lastName}` : ''} readOnly />
      </div>
      <div className="appointment-book-info">
        <div>Dein gewünschter Termin</div>
        <input 
          type="text" 
          value={date ? date.toLocaleDateString() : ''} 
          placeholder="Datum auswählen"
          className="appointment-book-input"
          readOnly 
          onClick={toggleCalendar}
        />
          {calenderOpen && (
            <Calendar 
              onChange={setDate} 
              value={date} 
            />
          )}
        </div>
      <div className="appointment-book-info">
        <div>Dein gewünschter Termin</div>
          <input 
            type="time" 
            value={time}
            onChange={(e) => setTime(e.target.value)}
            id="appt" 
            name="appt" 
            min="09:00" 
            max="18:00" 
            required 
          />
      </div>
      <div className="appointment-book-note">
        <div>Deine Nachricht</div>
        <textarea onChange={handleMessageChange}></textarea>
      </div>
      <button 
        className="appointment-book-button"
        onClick={handleButtonClick}
      >Termin vereinbaren</button>
    </div>
  );
};

export default AppointmentBook;
